export const Cross = '\u00D7'
